export default function Title(props) {
    return(
        <div className="font-header font-extrabold text-3xl inline text-grey-light">{props.text}</div>
    )
}